import React, {useState, useEffect} from 'react'
import {GatsbyImage,  getImage} from 'gatsby-plugin-image';
import ContextConsumer from "../../../../layouts/Context"

function Image({theImage, gallery}) {

    const [theImageIndex, setTheImageIndex ] = useState()
    const image = getImage(theImage);

    // console.log("IMAGE", image)
    useEffect(() => {
        gallery?.map((galleryImage, index) => {
            
            // console.log(galleryImage )
            if(galleryImage?.image?.localFile.childImageSharp.gatsbyImageData.images.fallback.src === image.images.fallback.src) {
                setTheImageIndex(index)
                console.log(index)
            }
        })
    }, [gallery]);

    return (
        <ContextConsumer>
            {({ data, set }) => (
            <div 
            className="image-wrapper" 
            key={`gallery_1`} 
            onClick={() => set({ 
                menuOpen: !data.menuOpen, 
                image: image,
                imageIndex: theImageIndex,
                theGallery:gallery,
            })}
            >
            <GatsbyImage image={image} className="image" alt={'test'} />
            </div>
            )}
        </ContextConsumer>
    )
}

export default Image
